export const FETCH_WORKFLOW_STATUS_LIST = 'FETCH_WORKFLOW_STATUS_LIST';
export const FETCH_WORKFLOW_STATUS_LIST_SUCCESS =
  'FETCH_WORKFLOW_STATUS_LIST_SUCCESS';
export const FETCH_WORKFLOW_STATUS_LIST_FAIL =
  'FETCH_WORKFLOW_STATUS_LIST_FAIL';
export const FETCH_ALERT_LEVEL = 'FETCH_ALERT_LEVEL';
export const FETCH_ALERT_LEVELS_SUCCESS = 'FETCH_ALERT_LEVELS_SUCCESS';
export const FETCH_ALERT_LEVELS_FAIL = 'FETCH_ALERT_LEVELS_FAIL';
export const UPDATE_ALERT_LEVEL = 'UPDATE_ALERT_LEVEL';
export const UPDATE_ALERT_LEVEL_SUCCESS = 'UPDATE_ALERT_LEVEL_SUCCESS';
export const UPDATE_ALERT_LEVEL_FAIL = 'UPDATE_ALERT_LEVEL_FAIL';
export const UPDATE_WORKFLOW_STATUS_LIST = 'UPDATE_WORKFLOW_STATUS_LIST';
export const UPDATE_WORKFLOW_STATUS_LIST_SUCCESS =
  'UPDATE_WORKFLOW_STATUS_LIST_SUCCESS';
export const UPDATE_WORKFLOW_STATUS_LIST_FAIL =
  'UPDATE_WORKFLOW_STATUS_LIST_FAIL';

export const fetchAlertLevel = () => ({
  type: FETCH_ALERT_LEVEL
});

export const fetchAlertLevelSuccess = (alertLevels) => ({
  type: FETCH_ALERT_LEVELS_SUCCESS,
  payload: alertLevels
});

export const fetchAlertLevelFail = (payload) => ({
  type: FETCH_ALERT_LEVELS_FAIL,
  payload: payload
});

export const fetchWorkFlowStatusList = () => ({
  type: FETCH_WORKFLOW_STATUS_LIST
});

export const fetchWorkFlowStatusListSuccess = (statusList) => ({
  type: FETCH_WORKFLOW_STATUS_LIST_SUCCESS,
  payload: statusList
});

export const fetchWorkFlowStatusListFail = (payload) => ({
  type: FETCH_WORKFLOW_STATUS_LIST_FAIL,
  payload
});

export const updateAlertLevel = (payload) => ({
  type: UPDATE_ALERT_LEVEL,
  payload
});

export const updateAlertLevelSuccess = () => ({
  type: UPDATE_ALERT_LEVEL_SUCCESS
});

export const updateAlertLevelFail = (payload) => ({
  type: UPDATE_ALERT_LEVEL_FAIL,
  payload: payload
});

export const updateWorkFlowStatusList = (statusList) => ({
  type: UPDATE_WORKFLOW_STATUS_LIST,
  payload: statusList
});

export const updateWorkFlowStatusListSuccess = () => ({
  type: UPDATE_WORKFLOW_STATUS_LIST_SUCCESS
});

export const updateWorkFlowStatusListFail = (payload) => ({
  type: UPDATE_WORKFLOW_STATUS_LIST_FAIL,
  payload
});
